"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function EyeIcon(_ref) {
  var hideUnselectedPersonas = _ref.hideUnselectedPersonas,
      handleHideUnselectedPersonas = _ref.handleHideUnselectedPersonas;

  var handleClick = function handleClick(event) {
    event.stopPropagation();
    handleHideUnselectedPersonas();
  };

  var message = (0, _reactRedux.useSelector)(function (state) {
    return state.audienceView.view.textPlural;
  });
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
    name: "eye",
    title: "Show/Hide selected " + message,
    className: "eye-icon " + (hideUnselectedPersonas ? 'active' : ''),
    onClick: handleClick
  });
}

var _default = EyeIcon;
exports["default"] = _default;